// multi select
export const BEGIN_MULTISELECT = `BEGIN_MULTISELECT`;
export const END_MULTISELECT = `END_MULTISELECT`;
export const SELECT_ITEM_MULTISELECT = `SELECT_ITEM_MULTISELECT`;
export const DESELECT_ITEM_MULTISELECT = `DESELECT_ITEM_MULTISELECT`;

// add dx
export const ADD_DX_REQUEST = 'ADD_DX_REQUEST';
export const ADD_DX_SUCCESS = 'ADD_DX_SUCCESS';
export const ADD_DX_FAILURE = 'ADD_DX_FAILURE';

// approve dx
export const APPROVE_DX_REQUEST = 'APPROVE_DX_REQUEST';
export const APPROVE_DX_SUCCESS = 'APPROVE_DX_SUCCESS';
export const APPROVE_DX_FAILURE = 'APPROVE_DX_FAILURE';

// unapprove dx
export const UNAPPROVE_DX_REQUEST = 'UNAPPROVE_DX_REQUEST';
export const UNAPPROVE_DX_SUCCESS = 'UNAPPROVE_DX_SUCCESS';
export const UNAPPROVE_DX_FAILURE = 'UNAPPROVE_DX_FAILURE';

// remove dx
export const REMOVE_DX_REQUEST = 'REMOVE_DX_REQUEST';
export const REMOVE_DX_SUCCESS = 'REMOVE_DX_SUCCESS';
export const REMOVE_DX_FAILURE = 'REMOVE_DX_FAILURE';

// unremove dx
export const UNREMOVE_DX_REQUEST = 'UNREMOVE_DX_REQUEST';
export const UNREMOVE_DX_SUCCESS = 'UNREMOVE_DX_SUCCESS';
export const UNREMOVE_DX_FAILURE = 'UNREMOVE_DX_FAILURE';

// hydrate dxes from init or wherever
export const HYDRATE = `HYDRATE`;
